import env from '~/src/utils/env';

const webviewerVersion = '8.12.4';
export const webviewerUrl = `${env.webviewerHost}/${webviewerVersion}`;
